import { useEffect, useState } from 'react';
import { useAuth } from '@/components/auth/SupabaseAuthProvider';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { useToast } from '@/hooks/use-toast';
import { PageContainer } from "@/components/layout/PageContainer";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const PAYMENT_LINKS = {
  'Free Trial': 'https://buy.stripe.com/14kaID9vs3at7MQ6oq',
  'Basic': 'https://buy.stripe.com/eVa6sn9vsfXfaZ2144',
  'Family': 'https://buy.stripe.com/eVa8Av6jgaCVgjm145'
};

export default function Payment() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(true);

  const plan = searchParams.get('plan');
  const price = searchParams.get('price');
  const priceId = searchParams.get('priceId');

  useEffect(() => {
    const initializePayment = async () => {
      if (!user) {
        navigate('/');
        return;
      }

      if (!plan || !price || !priceId) {
        toast({
          title: 'Error',
          description: 'Missing payment information',
          variant: 'destructive',
        });
        navigate('/subscription');
        return;
      }

      setIsLoading(true);

      const paymentLink = PAYMENT_LINKS[plan as keyof typeof PAYMENT_LINKS];

      if (paymentLink) {
        window.location.href = paymentLink;
      } else {
        console.error(`No payment link found for plan: ${plan}`);
        toast({
          title: 'Error',
          description: `Payment link not configured for ${plan}. Please contact support.`,
          variant: 'destructive',
        });
        setIsLoading(false);
        navigate('/subscription');
      }
    };

    initializePayment();
  }, [user, plan, price, priceId, navigate, toast]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Preparing your payment...</h1>
          <p>Please wait while we set up your checkout session.</p>
        </div>
      </div>
    );
  }

  return (
    <PageContainer>
      <div className="max-w-3xl mx-auto py-8 px-4">
        <Card className="p-6">
          <h1 className="text-3xl font-bold mb-6">Complete Your Subscription</h1>
          <div className="mb-6">
            <h2 className="text-xl font-semibold">{plan} Plan</h2>
            <p className="text-muted-foreground">{price}/month</p>
          </div>
          <Button 
            onClick={() => {}} 
            className="w-full"
          >
            Proceed to Payment
          </Button>
        </Card>
      </div>
    </PageContainer>
  );
}